// Playback-rate vocabulary shared by the editor timeline preview and the Visor
// player. Kept in common/ because the two live in separate bundles — the Visor
// must not pull _editor/ code in just to know which rates exist.

export const SPEED_PRESETS = [0.5, 1, 1.5, 2, 3, 4];

// A YouTube embed can only be driven at the rates its iframe API accepts, and
// 2x is the fastest of them. Scenes holding one cap playback there rather than
// letting the playhead run away from the video.
export const YOUTUBE_MAX_SPEED = 2;

export const formatSpeed = (speed) => `${speed}×`;

/**
 * Playhead position for a rate-scaled clock: the position playback resumed
 * from, plus the raw time elapsed since the anchor, scaled by the rate.
 *
 * Both Visor clock branches (the Web Audio hardware clock and the wall-clock
 * fallback) derive position this way, which is what makes a rate change a pure
 * re-anchor: capture the position, reset the anchor, and only the time that
 * follows is scaled. Scaling from a zero anchor instead would retroactively
 * rewrite what was already played and jump the playhead.
 */
export function scaledPosition(rawElapsedSec, rate, basePositionSec) {
  const r = Number(rate) > 0 ? Number(rate) : 1;
  return Math.max(0, (Number(rawElapsedSec) || 0) * r + (Number(basePositionSec) || 0));
}

/** Nearest valid preset at or below `rate`, honouring an optional ceiling. */
export function clampSpeed(rate, maxSpeed) {
  const allowed = SPEED_PRESETS.filter((s) => typeof maxSpeed !== "number" || s <= maxSpeed);
  if (!allowed.length) return 1;
  if (allowed.includes(rate)) return rate;
  return allowed.reduce((best, s) => (s <= rate && s > best ? s : best), allowed[0]);
}
